import { SURVEY_PROPERTIES_MAP } from 'constants/surveyJS/surveyOwnContants';
import { Serializer, SvgRegistry } from 'survey-core';
import { setLicenseKey } from 'survey-core';

export const initializeSurveyJS = () => {
  const customIcon =
    '<svg viewBox="0 0 12 12" width="18px" xmlns="http://www.w3.org/2000/svg"><path d="M11.35 1.34999L10.65 0.649994L6.05002 5.24999L1.35002 0.649994L0.650024 1.34999L5.25002 6.04999L0.650024 10.65L1.35002 11.35L6.05002 6.74999L10.65 11.35L11.35 10.65L6.75002 6.04999L11.35 1.34999Z"/></svg>';
  SvgRegistry.registerIconFromSvg('icon-v2check', customIcon);

  if (process.env.REACT_APP_SURVEY_JS_LICENSE_KEY) {
    setLicenseKey(process.env.REACT_APP_SURVEY_JS_LICENSE_KEY);
  }
  Serializer.addProperty('question', {
    name: SURVEY_PROPERTIES_MAP.TEST_VALUE,
    type: 'value',
    displayName: 'Test Value',
    category: 'data',
    visibleIndex: 2,
  });
  Serializer.addProperty('question', 'sparkUp');
  Serializer.addProperty('page', 'sparkUp');
};
